import React, { useMemo, useCallback, forwardRef } from "react";
import { marked } from "marked";
import { connect } from "react-redux";

import RichTextEditor from "../../../../shared/components/Editor/RichTextEditor";
import { eventBookingActions } from "../../../../redux/actions";
import { EMPTY_STRING, eventDetailsFields } from "../../../../constants";
import { updateEventDetailAIResponse } from "../../../../shared";

const EventTypeAIResponse = forwardRef((props, ref) => {
  const {
    formState,
    selectedEventId,
    onNext,
    setFormState,
    currentContent,
    setCurrentContent,
  } = props;

  // Find the current event
  const currentEvent = formState.find((e) => e.id === selectedEventId);

  // Memoized Markdown parsing for initial content
  const initialContent = useMemo(() => {
    return currentEvent?.eventType?.description
      ? marked.parse(currentEvent.eventType.description)
      : EMPTY_STRING;
    // eslint-disable-next-line
  }, [formState, selectedEventId]);

  // Memoized content change handler
  const handleContentChange = useCallback(
    (content) => {
      setCurrentContent(content);
    },
    // eslint-disable-next-line
    [selectedEventId]
  );

  // Memoized blur handler
  const handleOnBlur = useCallback(() => {
    if (!selectedEventId) return;

    const updatedFormState = updateEventDetailAIResponse({
      formState,
      eventId: selectedEventId,
      eventType: eventDetailsFields.EVENT_TYPE,
      description: eventDetailsFields.DESCRIPTION,
      value: currentContent,
    });
    setFormState(updatedFormState);
  }, [selectedEventId, formState, currentContent, setFormState]);

  // Memoized next handler
  const handleNext = useCallback(() => {
    if (onNext) onNext();
  }, [onNext]);

  return (
    <div className="event-type event-type-ai-response px-4 pb-3 mb-3" ref={ref}>
      <h4 className="event-type-title label-content-600">
        event shot list:
      </h4>
      <p className="event-type-description mb-0">
        we created this shot list for you.
      </p>
      <p className="event-type-description mb-3">
        this is your moment to get clear with your shutterb — think of it as the shared agreement that ensures they capture what matters most to you.
      </p>

      <div className="ai-response">
        <RichTextEditor
          onBlur={handleOnBlur}
          onContentChange={handleContentChange}
          initialContent={initialContent ?? EMPTY_STRING}
        />
      </div>
      
      <div className="d-flex justify-content-end sticky-button-row mt-4 pt-4 mb-lg-0">
        <button type="button" className="button-common button-fill" onClick={handleNext}>
          next
        </button>
      </div>
    </div>
  );
});

// Mapping the component's props to the reducer's state
const mapStateToProps = (state) => ({
  formState: state.eventBooking.formState,
  selectedEventId: state.eventBooking.selectedEventId,
});

// Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  setFormState: (data) => dispatch(eventBookingActions.setFormState(data)),
});

// mapping action and store the function via props
export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null, // no custom mergeProps, keep default
 { forwardRef: true } //to receive ref from HOC
)(EventTypeAIResponse);
